import Vuex from 'vuex'
import Vue from 'vue'
import gateway from '@/services/gateway'

Vue.use(Vuex)

const state = {
  user: null,
  client: null,
  env: null
}

export const mutations = {
  user(state, user) {
    state.user = user
  },
  client(state, client) {
    state.client = client
  },
  invoiceFilter(state, filter) {
    state.invoiceFilter = filter
  },
  declarationFilter(state, filter) {
    state.declarationFilter = filter
  },
  env(state, env) {
    state.env = env
  }
}

export const actions = {
  login(context) {
    return gateway.get('/current-user').then((r => {
      context.commit('user', r.data)
      context.commit('env', r.data.env)
    })).catch(r => {
      return r
    })
  },

  logout(context) {
    context.commit('user', null)
  }
}

export default new Vuex.Store({state, mutations, actions})
